import { useMemo } from 'react';

/**
 * Custom hook untuk memoisasi nilai berdasarkan dependencies.
 * @param computeFunction Fungsi yang menghasilkan nilai yang ingin dimemoisasi.
 * @param dependencies Array dependencies yang akan menentukan kapan nilai dihitung ulang.
 * @returns Nilai yang sudah dimemoisasi.
 */
function useMemoizedValue<T>(computeFunction: () => T, dependencies: unknown[]): T {
  return useMemo(computeFunction, [computeFunction, ...dependencies]);
}

export default useMemoizedValue;
